// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"c6bf1769","outerContainer":"_5697b961","secondaryToolbar":"a00fbf17","doorHangerRight":"_1dd345e6","toolbarContainer":"_985aa58b","toolbarViewerMiddle":"_3e9e0dc6","progressBar":"d8c41e07","back-to-application":"a6522cb5","card":"_2b830965","wrapper":"e4fca910","wrapper--placeholder":"_2598b046","header":"_8f5f900b","avatar":"_9b4eda38","content":"fa9f3d99","title":"abf635fd","subtitle":"_7e0b0a1a","footer":"ecbe02bd","image":"fd700bdc","link":"c6ed6eb2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Communities/Components/VerticalCard/index.styl
// module id = 2243
// module chunks = 39